var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-867.000000, -1201.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "book"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882.539272,1215.05196 C882.3893,1215.50899 882.3893,1216.86601 882.539272,1217.32304 C882.800014,1217.37227 883,1217.60079 883,1217.875 L883,1218.4375 C883,1218.74687 882.74285,1219 882.428571,1219 L869.857143,1219 C868.278564,1219 867,1217.74141 867,1216.1875 L867,1203.8125 C867,1202.25859 868.278564,1201 869.857143,1201 L882.428571,1201 C882.74285,1201 883,1201.25313 883,1201.5625 L883,1214.5 C883,1214.77421 882.803571,1214.99923 882.539272,1215.05196 Z M881.071429,1215.0625 L869.857143,1215.0625 C869.228585,1215.0625 868.714286,1215.56876 868.714286,1216.1875 C868.714286,1216.80977 869.224993,1217.3125 869.857143,1217.3125 L881.071429,1217.3125 C880.974993,1216.7043 880.974993,1215.6707 881.071429,1215.0625 Z M881.285714,1202.6875 L869.857143,1202.6875 C869.224993,1202.6875 868.714286,1203.19023 868.714286,1203.8125 L868.714286,1213.61055 C869.064279,1213.45939 869.449986,1213.375 869.857143,1213.375 L881.285714,1213.375 L881.285714,1202.6875 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.9c180bd1.svg";
export { ForwardRef as ReactComponent };